// Tipos de paquete que dan clases ilimitadas durante su vigencia.
// Debe mantenerse en sync con PackageHistory::MEMBERSHIP_TYPES del backend.
export const MEMBERSHIP_TYPES = [
  'ride_membership',
  'train_membership',
  'align_membership',
  'all_membership',
];

export const isMembership = (type) => MEMBERSHIP_TYPES.includes(type);
